<fa-icon [icon]="flag() ? yes() : no()"
         [class.text-muted]="!flag()"
         [class.text-success]="flag()"></fa-icon>